import { useSyncExternalStore } from "react";
import { isUpgradePromptOpen, subscribeUpgradePrompt } from "@/shared/lib/upgradePrompt";

/** Reactive view of whether the global upgrade prompt is open. */
export function useUpgradePromptOpen(): boolean {
  return useSyncExternalStore(subscribeUpgradePrompt, isUpgradePromptOpen, isUpgradePromptOpen);
}
